import React from 'react';
import SplitSection from '../common/split-section';
import { DESIGNED_BY_EXPERTS_DATA } from './constants';

const DesignedByExpertsSection: React.FC = () => {
  return (
    <section className="py-8 xl:py-24 lg:py-24 md:py-24">
      <SplitSection
        heading={DESIGNED_BY_EXPERTS_DATA.heading}
        headingClasses="w-1/2 flex items-left flex-col text-left sm:w-full"
        description={DESIGNED_BY_EXPERTS_DATA.description}
        classname="flex justify-between sm:flex-col-reverse wg-container flex-row-reverse items-center"
        child={
          <div className="w-1/2 flex justify-between items-left flex-col sm:w-full sm:hidden">
            <video
              src="https://assets1.cleartax-cdn.com/cleartax/images/1608208496_desktop_fold_designedbyexperts_lhs422.mp4"
              autoPlay
              loop
              muted
              playsInline
              controls={false}
              className="w-full h-auto"
            />
          </div>
        }
      />
    </section>
  );
};

export default DesignedByExpertsSection;
